var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.749,
    height: 10.75,
    viewBox: "0 0 10.749 10.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-edit",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M4.434,4.705A2.205,2.205,0,1,1,6.64,6.91,2.205,2.205,0,0,1,4.434,4.705ZM9.974,8.939a.221.221,0,0,0-.07-.132,2.953,2.953,0,0,0-2.167-.794H5.532A2.853,2.853,0,0,0,2.5,11.056a1.719,1.719,0,0,0,1.93,1.918H7.3a.15.15,0,0,0,.116-.05.179.179,0,0,0,.05-.119v-.934a.827.827,0,0,1,.243-.584L9.926,9.055A.17.17,0,0,0,9.974,8.939ZM8.289,11.872V13.25H9.667l2.5-2.491L10.78,9.37Zm4.8-2.806-.617-.617a.551.551,0,0,0-.777,0l-.529.535,1.389,1.389.535-.529a.551.551,0,0,0,0-.777Z",
    transform: "translate(0 0)",
    fill: "#6b6145"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/user-edit.b6da2281208e468851141e5372283760.svg";
export { ForwardRef as ReactComponent };